module.exports = __webpack_public_path__ + "static/media/7news-red.11380efe.png";